/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */
import type {
  CandidateFraudSignalsView,
  FraudFindingsVisibilityResponse,
  FraudSignalsGetFraudFindingsVisibilityParams,
  SharedContactMatchesView,
} from '../types';

import { axiosInstance } from '../../axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getFraudSignals = () => {
  /**
   * Read an application's checks through job VIEW access or its unrestricted transcript.
   * @summary Get Application Fraud Signals
   */
  const fraudSignalsGetApplicationFraudSignals = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<CandidateFraudSignalsView>>
  ) => {
    return axiosInstance<CandidateFraudSignalsView>(
      {
        url: `/candidates/${candidateId}/jobs/${campaignId}/fraud_signals`,
        method: 'GET',
      },
      options
    );
  };
  /**
 * Whether fraud risk findings show to the caller, for one job or anywhere in the org.

With ``campaign_id``: that job's effective fraud risk setting, after checking the job belongs to
the caller's org. Without: whether any job in the caller's org could show findings (the org
default is on, or a job overrides it to on). A support user signed in to the org sees findings
everywhere. The UI uses this to decide whether to render fraud columns, filters and badges; the
findings themselves are still withheld server-side wherever this would answer False.
 * @summary Get Fraud Findings Visibility
 */
  const fraudSignalsGetFraudFindingsVisibility = (
    params?: FraudSignalsGetFraudFindingsVisibilityParams,
    options?: SecondParameter<
      typeof axiosInstance<FraudFindingsVisibilityResponse>
    >
  ) => {
    return axiosInstance<FraudFindingsVisibilityResponse>(
      { url: `/fraud_signals/visibility`, method: 'GET', params },
      options
    );
  };
  /**
 * Name the other candidates sharing this candidate's email / phone / address / IP.

Session auth only, and only for within-org signals, so a shared transcript link cannot enumerate
an org's applicants and a cross-org count never resolves to a name. It explains a signal that
actually flagged rather than answering "who shares contact details with this candidate", so it
requires a flagged stored signal and names only members on jobs the caller may view.
 * @summary Get Shared Contact Matches
 */
  const fraudSignalsGetSharedContactMatches = (
    candidateId: string,
    signalId: string,
    options?: SecondParameter<typeof axiosInstance<SharedContactMatchesView>>
  ) => {
    return axiosInstance<SharedContactMatchesView>(
      {
        url: `/candidates/${candidateId}/fraud_signals/${signalId}/matches`,
        method: 'GET',
      },
      options
    );
  };
  return {
    fraudSignalsGetApplicationFraudSignals,
    fraudSignalsGetFraudFindingsVisibility,
    fraudSignalsGetSharedContactMatches,
  };
};
export type FraudSignalsGetApplicationFraudSignalsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getFraudSignals
      >['fraudSignalsGetApplicationFraudSignals']
    >
  >
>;
export type FraudSignalsGetFraudFindingsVisibilityResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getFraudSignals
      >['fraudSignalsGetFraudFindingsVisibility']
    >
  >
>;
export type FraudSignalsGetSharedContactMatchesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getFraudSignals>['fraudSignalsGetSharedContactMatches']
    >
  >
>;
